/**
 * @flow
 * @relayHash 21004ff1e5d6545f8e752f5c1b84a40d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MessagePaginator_query$ref = any;
export type MessagePaginatorQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  filterBy?: ?$ReadOnlyArray<string>,
  onlyActive: boolean,
  onlySent: boolean,
|};
export type MessagePaginatorQueryResponse = {|
  +$fragmentRefs: MessagePaginator_query$ref
|};
export type MessagePaginatorQuery = {|
  variables: MessagePaginatorQueryVariables,
  response: MessagePaginatorQueryResponse,
|};
*/


/*
query MessagePaginatorQuery(
  $count: Int!
  $cursor: String
  $search: String
  $filterBy: [ID!]
  $onlyActive: Boolean!
  $onlySent: Boolean!
) {
  ...MessagePaginator_query_1q7CkB
}

fragment BaseTitleCard_title on Title {
  id
  title
  publishingHouseDescription
  yearPublishedFirst
  datePublishedFirst
  yearPublishedLatest
  datePublishedLatest
  hasMoreAuthors
  popularityScore
  popularityScoreWeekAgo
  popularityScoreYesterday
  metaScore
  onlineMetaScore
  newspaperMetaScore
  reviewCount
  onlineReviewCount
  newspaperReviewCount
  category {
    id
    name
  }
  searchCategory {
    id
    name
  }
  authors {
    id
    name
  }
  publishingHouses {
    id
    name
  }
  coverImage {
    sizes {
      name
      url
    }
    id
  }
  publications {
    id
    availability
    isDigital
    publishingHouse {
      id
    }
    ...PublicationCard_publication
  }
  collections {
    id
    description
    name
    type
    isVerified
    titles {
      id
      title
      yearPublishedFirst
    }
  }
}

fragment BaseTitleCard_viewer on Customer {
  favoriteIds
  ...FavoriteStar_viewer
  ...PublicationCard_viewer
}

fragment FavoriteStar_viewer on Customer {
  favoriteIds
}

fragment MessageCard_message on Message {
  id
  activeFrom
  body
  canEdit
  includeLinkToBogportalen
  isActive
  status
  subject
  timestampCreated
  sender {
    id
    name
    type
    isAdministrator
    group {
      name
      type
      parentGroups {
        name
        id
      }
      id
    }
  }
  links {
    url
    description
  }
  attachments {
    description
    file {
      url
      id
    }
  }
  referencedPublications {
    isbn13
    id
  }
  aggregateReferencedTitles {
    title
    id
  }
  referencedEntities {
    name
    id
  }
  referencedPublishingHouses {
    name
    id
  }
}

fragment MessageCard_viewer on Customer {
  id
}

fragment MessagePaginator_query_1q7CkB on Query {
  viewer {
    messages(first: $count, after: $cursor, search: $search, filterBy: $filterBy, onlyActive: $onlyActive, onlySent: $onlySent) {
      totalCount
      edges {
        node {
          id
          isDeleted
          date
          aggregateReferencedTitles {
            id
          }
          referencedTitles {
            id
            ...PopularityTitleCard_title
          }
          referencedPublications {
            id
            titleId
            availability
            isDigital
            ...PublicationCard_publication
          }
          referencedPublishingHouses {
            id
          }
          referencedEntities {
            id
          }
          ...MessageCard_message
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    ...MessageCard_viewer
    ...PublicationCard_viewer
    ...PopularityTitleCard_viewer
    id
  }
}

fragment PopularityTitleCard_title on Title {
  datePublishedFirst
  hasMoreAuthors
  title
  authors {
    id
    name
  }
  popularityScore120DayHistory {
    date
    score
  }
  ...BaseTitleCard_title
}

fragment PopularityTitleCard_viewer on Customer {
  ...BaseTitleCard_viewer
}

fragment PublicationCard_publication on Publication {
  id
  title
  subtitle
  format
  pageCount
  isbn13
  datePublished
  yearPublished
  priceRetail
  availability
  isDigital
  hasMoreTranslators
  hasMoreAuthors
  authors {
    id
    name
  }
  translators {
    id
    name
  }
  publishingHouse {
    id
    name
  }
  coverImage {
    sizes {
      name
      url
    }
    id
  }
}

fragment PublicationCard_viewer on Customer {
  ...FavoriteStar_viewer
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "filterBy",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "onlyActive",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "onlySent",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "filterBy",
  "variableName": "filterBy"
},
v2 = {
  "kind": "Variable",
  "name": "onlyActive",
  "variableName": "onlyActive"
},
v3 = {
  "kind": "Variable",
  "name": "onlySent",
  "variableName": "onlySent"
},
v4 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "date",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasMoreAuthors",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v11 = [
  (v6/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "authors",
  "storageKey": null,
  "args": null,
  "concreteType": "Entity",
  "plural": true,
  "selections": (v11/*: any*/)
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "yearPublishedFirst",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "coverImage",
  "storageKey": null,
  "args": null,
  "concreteType": "PublicationCoverImage",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sizes",
      "storageKey": null,
      "args": null,
      "concreteType": "PublicationCoverImageSize",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        (v14/*: any*/)
      ]
    },
    (v6/*: any*/)
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "availability",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isDigital",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publishingHouse",
  "storageKey": null,
  "args": null,
  "concreteType": "PublishingHouse",
  "plural": false,
  "selections": (v11/*: any*/)
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subtitle",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "format",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pageCount",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isbn13",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "datePublished",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "yearPublished",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "priceRetail",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasMoreTranslators",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "translators",
  "storageKey": null,
  "args": null,
  "concreteType": "Entity",
  "plural": true,
  "selections": (v11/*: any*/)
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MessagePaginatorQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "MessagePaginator_query",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MessagePaginatorQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Customer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "messages",
            "storageKey": null,
            "args": (v5/*: any*/),
            "concreteType": "MessageConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "MessageEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Message",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDeleted",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "aggregateReferencedTitles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Title",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedTitles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Title",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "datePublishedFirst",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v8/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "popularityScore120DayHistory",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "HistoricalDailyPopularityScore",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "score",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "publishingHouseDescription",
                            "args": null,
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "yearPublishedLatest",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "datePublishedLatest",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "popularityScore",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "popularityScoreWeekAgo",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "popularityScoreYesterday",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "metaScore",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "onlineMetaScore",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "newspaperMetaScore",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "reviewCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "onlineReviewCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "newspaperReviewCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Category",
                            "plural": false,
                            "selections": (v11/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "searchCategory",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SearchCategory",
                            "plural": false,
                            "selections": (v11/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "publishingHouses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PublishingHouse",
                            "plural": true,
                            "selections": (v11/*: any*/)
                          },
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "publications",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Publication",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v27/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "collections",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Collection",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v28/*: any*/),
                              (v10/*: any*/),
                              (v29/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isVerified",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "titles",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Title",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v8/*: any*/),
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedPublications",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Publication",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "titleId",
                            "args": null,
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v8/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v27/*: any*/),
                          (v18/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedPublishingHouses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PublishingHouse",
                        "plural": true,
                        "selections": (v11/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedEntities",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": true,
                        "selections": (v11/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "activeFrom",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "body",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canEdit",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "includeLinkToBogportalen",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isActive",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subject",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "timestampCreated",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sender",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Customer",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v29/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isAdministrator",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "group",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CustomerGroup",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v29/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "parentGroups",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CustomerGroup",
                                "plural": true,
                                "selections": [
                                  (v10/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "links",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MessageLink",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v28/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "attachments",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MessageAttachhment",
                        "plural": true,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "file",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "File",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "messages",
            "args": (v5/*: any*/),
            "handle": "connection",
            "key": "MessagePaginator_messages",
            "filters": [
              "search",
              "filterBy",
              "onlyActive",
              "onlySent"
            ]
          },
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "favoriteIds",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MessagePaginatorQuery",
    "id": null,
    "text": "query MessagePaginatorQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $filterBy: [ID!]\n  $onlyActive: Boolean!\n  $onlySent: Boolean!\n) {\n  ...MessagePaginator_query_1q7CkB\n}\n\nfragment BaseTitleCard_title on Title {\n  id\n  title\n  publishingHouseDescription\n  yearPublishedFirst\n  datePublishedFirst\n  yearPublishedLatest\n  datePublishedLatest\n  hasMoreAuthors\n  popularityScore\n  popularityScoreWeekAgo\n  popularityScoreYesterday\n  metaScore\n  onlineMetaScore\n  newspaperMetaScore\n  reviewCount\n  onlineReviewCount\n  newspaperReviewCount\n  category {\n    id\n    name\n  }\n  searchCategory {\n    id\n    name\n  }\n  authors {\n    id\n    name\n  }\n  publishingHouses {\n    id\n    name\n  }\n  coverImage {\n    sizes {\n      name\n      url\n    }\n    id\n  }\n  publications {\n    id\n    availability\n    isDigital\n    publishingHouse {\n      id\n    }\n    ...PublicationCard_publication\n  }\n  collections {\n    id\n    description\n    name\n    type\n    isVerified\n    titles {\n      id\n      title\n      yearPublishedFirst\n    }\n  }\n}\n\nfragment BaseTitleCard_viewer on Customer {\n  favoriteIds\n  ...FavoriteStar_viewer\n  ...PublicationCard_viewer\n}\n\nfragment FavoriteStar_viewer on Customer {\n  favoriteIds\n}\n\nfragment MessageCard_message on Message {\n  id\n  activeFrom\n  body\n  canEdit\n  includeLinkToBogportalen\n  isActive\n  status\n  subject\n  timestampCreated\n  sender {\n    id\n    name\n    type\n    isAdministrator\n    group {\n      name\n      type\n      parentGroups {\n        name\n        id\n      }\n      id\n    }\n  }\n  links {\n    url\n    description\n  }\n  attachments {\n    description\n    file {\n      url\n      id\n    }\n  }\n  referencedPublications {\n    isbn13\n    id\n  }\n  aggregateReferencedTitles {\n    title\n    id\n  }\n  referencedEntities {\n    name\n    id\n  }\n  referencedPublishingHouses {\n    name\n    id\n  }\n}\n\nfragment MessageCard_viewer on Customer {\n  id\n}\n\nfragment MessagePaginator_query_1q7CkB on Query {\n  viewer {\n    messages(first: $count, after: $cursor, search: $search, filterBy: $filterBy, onlyActive: $onlyActive, onlySent: $onlySent) {\n      totalCount\n      edges {\n        node {\n          id\n          isDeleted\n          date\n          aggregateReferencedTitles {\n            id\n          }\n          referencedTitles {\n            id\n            ...PopularityTitleCard_title\n          }\n          referencedPublications {\n            id\n            titleId\n            availability\n            isDigital\n            ...PublicationCard_publication\n          }\n          referencedPublishingHouses {\n            id\n          }\n          referencedEntities {\n            id\n          }\n          ...MessageCard_message\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...MessageCard_viewer\n    ...PublicationCard_viewer\n    ...PopularityTitleCard_viewer\n    id\n  }\n}\n\nfragment PopularityTitleCard_title on Title {\n  datePublishedFirst\n  hasMoreAuthors\n  title\n  authors {\n    id\n    name\n  }\n  popularityScore120DayHistory {\n    date\n    score\n  }\n  ...BaseTitleCard_title\n}\n\nfragment PopularityTitleCard_viewer on Customer {\n  ...BaseTitleCard_viewer\n}\n\nfragment PublicationCard_publication on Publication {\n  id\n  title\n  subtitle\n  format\n  pageCount\n  isbn13\n  datePublished\n  yearPublished\n  priceRetail\n  availability\n  isDigital\n  hasMoreTranslators\n  hasMoreAuthors\n  authors {\n    id\n    name\n  }\n  translators {\n    id\n    name\n  }\n  publishingHouse {\n    id\n    name\n  }\n  coverImage {\n    sizes {\n      name\n      url\n    }\n    id\n  }\n}\n\nfragment PublicationCard_viewer on Customer {\n  ...FavoriteStar_viewer\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0725872e59df7f7b0ef35b8d89ed3c42';
module.exports = node;
